(function(window, angular) {
  "use strict";

	angular.module('service')
	.factory('userService', ['baseService', function(baseService) {
		// inherits
		var extended = angular.copy(baseService);
		// url
		extended.base_url = getFullUrl('/api/user');

		return extended;
	}]);
})(window, window.angular);
